// extracted by mini-css-extract-plugin
module.exports = {"error":"LoginErrorWindow_error__3iWLh","languageSelector":"LoginErrorWindow_languageSelector__3agdp","button":"LoginErrorWindow_button__2A2GR"};